<template>
  <v-data-table
    :headers="columnKeys"
    :items="items"
    :options="pagination"
    :items-per-page="pagination.limit"
    :server-items-length="pagination.totalItems"
    @update:options="changePage"
    :loading="loading"
  >
    <template v-slot:header.name="{ header }">
      <div style="min-width: 120px">{{ header.text }}</div>
    </template>

    <template v-slot:progress>
      <v-progress-linear :color="Theme.PINK" :height="3" indeterminate />
    </template>

    <template v-slot:body="{ items }">
      <tbody>
        <tr v-for="(item, i) in items" :key="i">
          <td v-for="col in columnKeys" :key="col.key" style="min-width: 120px">
            <v-btn
              :color="col.color ? col.color : 'red'"
              :dark="!disabledStatus(col.value, item)"
              v-if="col.isEvent"
              :disabled="disabledStatus(col.value, item)"
              @click.stop="cellEvent(col.value, item)"
              >{{ col.text }}</v-btn
            >
            <v-img
              width="100px"
              height="100px"
              v-else-if="col.isImage"
              aspect-ratio="1"
              :src="formatURL(item.path)"
            ></v-img>
            <v-btn
              flat
              text
              v-else-if="col.isTextEvent"
              @click.stop="cellEvent(col.value, item)"
              >{{ item[col.value] }}</v-btn
            >
            <span v-else-if="col.value === 'counter'">{{
              getSelectCounterList(col, item)
            }}</span>
            <span v-else-if="col.options">{{ getSelectList(col, item) }}</span>
            <span v-else>{{ getValue(col, item[`${col.value}`]) }}</span>
          </td>
        </tr>
      </tbody>
    </template>

    <template v-slot:no-data>
      <v-btn :color="Theme.GREEN" @click="reloadData">重新整理</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import common from "@/mixins/common";

export default {
  name: "TableView",
  mixins: [common],
  props: {
    columnKeys: Array,
    items: Array,
    loading: Boolean,
    pagination: Object,
    counters: {
      type: Array,
      required: false,
    },
  },
  methods: {
    getSelectList(col, option) {
      console.log(`getSelectList === ${option[col.value]}`);
      const find = col.options.find(
        (item) =>
          item.key === option[col.value] ||
          item.key === parseInt(option[col.value])
      );
      if (find) {
        return find.text;
      }
      return "--";
    },
    getSelectCounterList(col, option) {
      const counterIDs = option[col.value];
      let counterItems = [];
      if (!this.counterList) {
        return "--";
      }
      for (let i = 0; i < counterIDs.length; i++) {
        const counterId = counterIDs[i];
        const list = this.counterList ?? [];
        const find = list.find(
          (item) => item.counterId === counterId
        );
        if (find) {
          counterItems.push(find.name);
        }
      }
      return counterItems.length ? counterItems.toString() : "--";
    },
    changePage(page) {
      console.log(`page ${JSON.stringify(page)}`);
      this.$emit("changePage", page);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    cellEvent(key, item) {
      this.$emit("cellEvent", { key: key, item: item });
    },
    getValue(col, text) {
      // console.log(`${JSON.stringify(col)} / text === ${text}`);
      if (col.emptyValue === "") {
        return text;
      } else {
        if (!text || text === "") {
          return col.emptyValue;
        }
        return text;
      }
    },
    reloadData() {
      // 重整
      this.$emit("handleLoadData");
    },
    formatURL(path) {
      const newPath = path.replace("public/", "");
      const url = `https://innovision.com.tw/${newPath}`;
      return url;
    },
    disabledStatus(key, item) {
      if (item["watsonsStatus"] !== "undefined") {
        if (
          (item["watsonsStatus"] === 1 && key === "createOrder") ||
          (!item["watsonsStatus"] && key === "refundsOrder") ||
          (!item["watsonsStatus"] === -1 &&
            (key === "refundsOrder" || "createOrder"))
          // (!item['watsonsStatus'] !== 1 && (key === 'printLabel'))
        ) {
          return true;
        }
      }
      return false;
    },
  },
  computed: {
    counterList() {
      return this.counters;
    },
  },
};
</script>

<style scoped></style>
